import { action } from 'easy-peasy';

import { IActionSetFavoriteReports } from '../types';

const setFavoriteReports: IActionSetFavoriteReports = action((state, payload) => {
  state.favoriteReports = payload;
});

export default setFavoriteReports;
